import LocationPageTemplate from '../components/LocationPageTemplate';
export default function SilverSpringPage() { return <LocationPageTemplate locationSlug="silver-spring" />; }
